import EditIcon from "@mui/icons-material/EditOutlined";
import SettingsIcon from "@mui/icons-material/SettingsOutlined";
import { Button, Stack, Typography } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import type { WorkflowTemplateActivity } from "../../../../../api/types/workflowTypes";
import { pageRoutes } from "../../../../../routes";
import WorkflowTemplateDetailsContext from "../WorkflowTemplateDetailsContext";
import WorkflowActivityDetailsDrawer from "./WorkflowActivityDetailsDrawer";

interface Props {
  activity: WorkflowTemplateActivity;
}

const WorkflowActivityCardContent = ({ activity }: Props) => {
  const { hasEditPermissions } = useDefinedContext(WorkflowTemplateDetailsContext);
  const navigate = useNavigate();

  const [showDetails, setShowDetails] = useState(false);

  return (
    <>
      <Stack spacing={1}>
        <Typography color="textSecondary">{activity.description}</Typography>

        {Boolean(activity.outputFieldSchema?.fields.length) && (
          <Button
            variant="outlined"
            color="secondary"
            startIcon={<EditIcon />}
            onClick={() => navigate(`${pageRoutes.workflowActivity}/${activity.id}/${pageRoutes.fields}`)}
          >
            Edit Fields
          </Button>
        )}

        {activity.isAiPowered && hasEditPermissions && (
          <Button
            variant="outlined"
            color="secondary"
            startIcon={<SettingsIcon />}
            onClick={() => setShowDetails(true)}
          >
            Configure
          </Button>
        )}
      </Stack>
      {showDetails && <WorkflowActivityDetailsDrawer activity={activity} onClose={() => setShowDetails(false)} />}
    </>
  );
};

export default WorkflowActivityCardContent;
